import { render, staticRenderFns } from "./UploadAllFile.vue?vue&type=template&id=1c661e3d&scoped=true&"
import script from "./UploadAllFile.vue?vue&type=script&lang=js&"
export * from "./UploadAllFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadAllFile.vue?vue&type=style&index=0&id=1c661e3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c661e3d",
  null
  
)

export default component.exports